import React, { useState, createContext } from 'react';
import { accessTokenRequest, getUserData } from '../global/global.service';

export const PublicUsersProfileContext = createContext();

export const PublicUsersProfileContextProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [notFound, setNotFound] = useState(false);

  const getUser = (user) => {
    accessTokenRequest()
      .then((response) => {
        getUserData(
          {
            users: [user],
          },
          response
        )
          .then((res) => {
            res.data.members && setUserInfo(res.data.members[0]);
            !res.data.members.length > 0 && setNotFound(true);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  return (
    <PublicUsersProfileContext.Provider value={{ userInfo, notFound, getUser }}>
      {children}
    </PublicUsersProfileContext.Provider>
  );
};
